"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetContainer = void 0;
require("reflect-metadata");
const inversify_1 = require("inversify");
const assets_types_1 = require("./assets.types");
const ui_core_api_gateway_1 = require("@desygner/ui-core-api-gateway");
const assets_service_1 = require("./assets.service");
const assetContainer = new inversify_1.Container({
    skipBaseClassChecks: true,
});
exports.assetContainer = assetContainer;
assetContainer.load(ui_core_api_gateway_1.container);
assetContainer
    .bind(assets_types_1.TYPES.WorkspaceAssets)
    .to(assets_service_1.WorkspaceAssetsService)
    .inSingletonScope();
assetContainer
    .bind(assets_types_1.TYPES.UserAssets)
    .to(assets_service_1.UserAssetsService)
    .inSingletonScope();
//# sourceMappingURL=assets.bootstrap.js.map